export const MULTI_CHECKBOX_INPUT_TABLE_TYPES = {
  TEXT: "text",
  CHECKBOX: "checkbox",
  CUSTOM: "custom",
} as const;

export const MULTI_CHECKBOX_INPUT_ALIGN_TYPES = {
  LEFT: "left",
  CENTER: "center",
  RIGHT: "right",
} as const;
